import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { BenefitsSection, BenefitTitle, BenefitDescription, LoginButton, Trials, Manage, Flexible } from "./styles";

import { getPartnerImageUrl } from "utils/getImageUrl";
import { userState } from "state/user-slice";
import { configState } from "state/config-slice";
import getOpco from "utils/getOpco";

import FeatureWrapper from "components/FeatureToggle/FeatureWrapper";

const Benefits = () => {
  const { t } = useTranslation();
  const { cdnUrl } = useSelector(configState);
  const OpcolessCdnUrl = cdnUrl.replace(`/${getOpco()}/`, "/");

  const benefits = [
    {
      imageUrl: "generic/benefits/benefit-1.webp",
      imageWidth: 150,
      title: t("Free trials"),
      description: t("Extended free trials with most services"),
      Component: Trials,
    },
    {
      imageUrl: "generic/benefits/benefit-2.webp",
      imageWidth: 150,
      title: t("Manage all in one place"),
      description: t("Easily manage available subscriptions in one place"),
      Component: Manage,
    },
    {
      imageUrl: "generic/benefits/benefit-3.webp",
      imageWidth: 150,
      title: t("Flexible for you"),
      description: t("You have the choice for how long you want your subscription for"),
      Component: Flexible,
    },
  ];

  return (
    <>
      {benefits.map(({ Component, description, title, imageUrl, imageWidth }) => (
        <Component key={imageUrl}>
          <img src={getPartnerImageUrl(imageUrl, OpcolessCdnUrl)} alt="person" width={imageWidth}></img>
          <BenefitTitle>{title}</BenefitTitle>
          <BenefitDescription>{description}</BenefitDescription>
        </Component>
      ))}
    </>
  );
};

const ProcessExposition: FunctionComponent = () => {
  const { t } = useTranslation();
  const config = useSelector(configState);
  const url = config.openidUrls?.find((el) => el.type === "bronze" || el.type === "gold")?.url as string;
  const currentUser = useSelector(userState);

  return (
    <FeatureWrapper name="Bruno Images">
      <BenefitsSection data-testid="process-exposition">
        <Benefits />
        {!currentUser.loggedIn && (
          <LoginButton data-testid="loginToGetStartedButtonBenefits" disabled={false} href={url}>
            {t("Login To Get Started")}
          </LoginButton>
        )}
      </BenefitsSection>
    </FeatureWrapper>
  );
};

export default React.memo(ProcessExposition);
